import moment from 'moment';
const validateDateAici = (value: string) => {

  if (
    moment(value, "DD-MM-YYYY", true).isValid() ||
    moment(value).isValid() ||
    moment(value, 'L').isValid()
  ) {
    const year = moment(value, "DD-MM-YYYY", true).year();
    if (year < 1900) {
      return {
        isValid: false,
        message: "Vous devez être né après 1900",
      };
    }
    return {
      isValid: true,
      message: "",
    };
  } else {
    return {
      isValid: false,
      message: "Veuillez entrez une date valide",
    };
  }
};

export default validateDateAici;
